<template>
  <div id="menu-comm">
    <div v-show="menuData.visible" :style="{left:menuData.left+'px',top:menuData.top+'px'}" class="menu">
      <div class="contextmenu__item"
           v-if="menuData.currentColumn.property===`target_name`&&[1,2].indexOf(menuData.currentRow.target_type)>-1"
           @click="selectEvent('addName')">
        <i class="el-icon-plus"></i>&nbsp;自定义目标
      </div>
      <div class="contextmenu__item" v-if="menuData.currentColumn.property===`target_term`&&menuData.currentRow.info_id"
           @click="selectEvent('editTerm')">
        <i class="el-icon-edit"></i>目标大项:&nbsp;{{ menuData.currentRow.target_term }}
      </div>
      <div class="contextmenu__item"
           v-if="menuData.currentColumn.property===`target_term`&&menuData.currentRow.info_id&&menuData.currentRow.target_type!==1"
           @click="selectEvent('delTerm')">
        <i class="el-icon-close"></i>目标大项:&nbsp;{{ menuData.currentRow.target_term }}
      </div>
      <div class="contextmenu__item" v-if="menuData.currentColumn.property===`target_term`"
           @click="selectEvent('addDsp')">
        <i class="el-icon-plus"></i>&nbsp;目标描述
      </div>
      <div class="contextmenu__item" v-if="menuData.currentColumn.property===`target_dsp`&&menuData.currentRow.item_id"
           @click="selectEvent('editDsp')">
        <i class="el-icon-edit"></i>&nbsp;目标描述
      </div>
      <div class="contextmenu__item" v-if="menuData.currentColumn.property===`target_dsp`&&menuData.currentRow.info_id"
           @click="selectEvent('addDsp')">
        <i class="el-icon-plus"></i>&nbsp;目标描述
      </div>
      <div class="contextmenu__item" v-if="menuData.currentColumn.property===`lower_w`&&menuData.currentRow.info_id"
           @click="selectEvent('editLowerW')">
        <i class="el-icon-edit"></i>&nbsp;权重（下限）
      </div>
      <div class="contextmenu__item" v-if="menuData.currentColumn.property===`upper_w`&&menuData.currentRow.info_id"
           @click="selectEvent('editUpperW')">
        <i class="el-icon-edit"></i>&nbsp;权重（上限）
      </div>
      <div class="contextmenu__item" v-if="menuData.currentColumn.property===`real_w`&&menuData.currentRow.info_id"
           @click="selectEvent('editRealW')">
        <i class="el-icon-edit"></i>&nbsp;核算权重
      </div>
      <div class="contextmenu__item" v-if="menuData.currentColumn.property===`real_intro`&& menuData.currentRow.item_id"
           @click="selectEvent('editRealIntro')">
        <i class="el-icon-edit"></i>&nbsp;完成情况
      </div>
      <!--      {{ menuData.currentColumn.property }} {{ menuData.currentRow.info_id }}-->
    </div>
  </div>
</template>

<script>
export default {
  name: "PerformanceDeptContextmenu",
  props: {
    menuData: {
      type: Object,
      default() {
        return {
          visible: false,
          top: 0,
          left: 0,
          currentRow: {},
          currentColumn: {}
        }
      }
    }
  },
  watch: {
    menuData: {
      deep: true,
      handler() {
        // this.initList()
      }
    }
  },
  data() {
    return {
      menuVisible: false,
    }
  },
  methods: {
    closeMenu() {
      this.menuData.visible = false;
    },
    selectEvent(val) {
      this.$emit('change', val)
      this.menuData.visible = false;
    },
  }
}
</script>

<style scoped>

.menu {
  position: absolute;
  background-color: #fff;
  width: 220px;
  /*height: 106px;*/
  font-size: 14px;
  color: #444040;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  white-space: nowrap;
  z-index: 1000;
}
</style>
